export default "__VITE_ASSET__DBBybm8u__"